<template>
  <g>
    <path
      d="M19.41 7.41018L14.58 2.58018C14.21 2.21018 13.7 2.00018 13.17 2.00018H6C4.9 2.00018 4 2.90018 4 4.00018V20.0002C4 21.1002 4.9 22.0002 6 22.0002H18C19.1 22.0002 20 21.1002 20 20.0002V8.83018C20 8.30018 19.79 7.79018 19.41 7.41018ZM15.74 18.7402C15.35 19.1302 14.72 19.1302 14.33 18.7402L13.15 17.5602C11.82 18.2702 10.14 18.0902 9.02 16.9702C7.5 15.4502 7.67 12.8902 9.52 11.6002C10.68 10.7902 12.3 10.7902 13.47 11.6002C15.02 12.6802 15.37 14.6402 14.56 16.1502L15.74 17.3302C16.13 17.7202 16.13 18.3502 15.74 18.7402ZM14 9.00018C13.45 9.00018 13 8.55018 13 8.00018V3.50018L18.5 9.00018H14Z"
    />
    <path
      d="M11.5 16.0002C12.3284 16.0002 13 15.3286 13 14.5002C13 13.6718 12.3284 13.0002 11.5 13.0002C10.6716 13.0002 10 13.6718 10 14.5002C10 15.3286 10.6716 16.0002 11.5 16.0002Z"
    />
  </g>
</template>
